<template>
  <div class="block generateAnalysisFile" :class="{ fullScreen: fullScreen }">
    <div class="tool">
      <div @click="fullScreen = !fullScreen">
        <Icon v-if="!fullScreen" type="ios-expand" />
        <Icon v-else type="md-close" />
      </div>
    </div>
    <div class="mk">
      <h2 style="text-align: center">病情解释</h2>
      <h3>1、患者主要情况</h3>
      <ul>
        <h4>(1) 概括讲患者分别有哪几条线路（病）：</h4>
        <ul>
          <div class="content" v-for="(g, g_index) in ['oneList', 'twoList', 'linksRelation']" :key="g_index">
            <div class="item" v-for="(item, index) in data[g]" :key="index">
              <!-- <div v-if="index > 1 && /线路\d+/.test(item)">
                比喻：<span class="blue">（请补充）</span>
              </div> -->
              <div :class="{ strong: !index }" v-html="item"></div>
            </div>
          </div>
        </ul>
        <h4>(2) 讲解和上一次相比有变化的线路的病机概括以及原因</h4>
        <ul v-if="data.reduceSet.length || data.increaseSet.length">
          与初诊相比，
          <span v-if="data.reduceSet.length">
            减少了{{ data.reduceSet.join("，") }}
          </span>
          <span v-if="data.increaseSet.length">
            ；增加了{{ data.increaseSet.join("，") }}
          </span>
        </ul>
        <h4>(3) 交汇点的病因病机演变：</h4>
        <ul>
          <div v-for="(item, index) in data.crossSet" :key="index">
            {{ item }}
          </div>
        </ul>
        <h4>(4) 用比喻的方式概括病情：<span class="blue">（请补充）</span></h4>
      </ul>

      <h3>2、患者反馈的问题及原因：<span class="blue">（请补充）</span></h3>
      <h3>3、好转症状及原因：</h3>
      <ul>
        <div>
          <span v-if="removeSymptom.length">
            消失： {{ removeSymptom.join("，") }}。
          </span>
          <span v-if="reduceSymptom.length">
            减轻： {{ reduceSymptom.join("，") }}。
          </span>
        </div>
        <div>原因：<span class="blue">（请补充）</span></div>
      </ul>
      <h3>4、治则：<span class="blue">（请补充）</span></h3>
      <h3>5、医嘱：<span class="blue">（请补充）</span></h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fullScreen: false,
      dialecticsAndSymptoms: {}, //辩证与症状
      removeSymptom: [], //消失的症状
      reduceSymptom: [], //减轻的症状
      differData: {
        same: [],
        add: [],
        remove: [],
      },
    };
  },
  methods: {
    formatKeywords(keywords) {
      return keywords
        .split(/，【减】：/)[0]
        .split(/，【既往史】：/)[0]
        .replace(/【.*?】：/gi, "")
        .replace(/，/gi, ",")
        .replace(/"/gi, "")
        .replace(/\n/gi, "")
        .replace(/，*\s*增：/gi, ",")
        .split(/，*\s*减：/)[0];
    },
    // 找到减轻组
    findJq(str) {
      let jq = [];
      let arr = str.replace(/】/gi, "").split(/，*【/);
      arr.forEach((i) => {
        let s = i.split("：");
        if (s[0] == "减轻") {
          jq = s[1].split(/，/);
        }
      });
      return jq;
    },
    init() {
      this.reduceSymptom = this.data.returnVisitKeywords ? this.findJq(this.data.returnVisitKeywords) : [];
      let k1 = this.data.keywords ? this.formatKeywords(this.data.keywords).split(/[，,]/).filter((i) => i) : [];
      let k2 = this.data.returnVisitKeywords ? this.formatKeywords(this.data.returnVisitKeywords).split(/[，,]/).filter((i) => i) : [];

      if (k2.length > 0) {
        this.differData = this.common.differ(k1, k2);
        this.removeSymptom = this.differData.remove;
      } else {
        this.removeSymptom = [];
      }
      [...this.data.dx, ...this.data.fdx].forEach((i) => {
        this.dialecticsAndSymptoms[i.dialecticsName] = i.dsName;
      });
      let d = this.data;
      ["reduceSet", "increaseSet"].forEach((key) => {
        let list =
          key == "reduceSet" ? this.differData.remove : this.differData.add;

        d[key] = this.data[key].map((i) => {
          let dsName = this.dialecticsAndSymptoms[i];
          return dsName && list.includes(dsName) ? `${i}(${dsName})` : i;
        });
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.generateAnalysisFile {
  margin-bottom: 15px;
  line-height: 1.8em;
  height: 100%;
  overflow: auto;
  position: relative;

  &.fullScreen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    background: #fff;
    z-index: 1002;
  }

  .tool {
    position: absolute;
    z-index: 10;
    right: 15px;
    top: 15px;
    font-size: 22px;
    cursor: pointer;
  }

  .strong {
    font-weight: bold;
  }

  ul {
    padding-left: 15px;
  }
}
</style>
